{
	"playground.playground-local-execution-message.message-template-template.email.body.img.alt.no-translate": {
		"defaultMessage": "Description of image",
		"description": "alt text for the image"
	},
	"playground.playground-local-execution-message.message-template.email.subject.no-translate": {
		"defaultMessage": "Post Office Test Message from {env}",
		"description": "Local execution test message"
	},
	"playground.playground-local-execution-message.test-message.email.body.hello.no-translate": {
		"defaultMessage": "Hello, fellow child {name},",
		"description": "hello message (body) of the email"
	},
	"playground.playground-local-execution-message.test-message.email.body.no-translate": {
		"defaultMessage": "We are currently trying to locally execute this message!",
		"description": "body of the email"
	},
	"playground.playground-local-execution-message.test-message.email.body.regards.no-translate": {
		"defaultMessage": "Playground Team",
		"description": "post office team"
	},
	"playground.playground-local-execution-message.test-message.email.body.signoff.no-translate": {
		"defaultMessage": "Regards,",
		"description": "email signoff"
	},
	"playground.playground-local-execution-message.test-message.email.unsubscribe.text.no-translate": {
		"defaultMessage": "Unsubscribe",
		"description": "Unsubscribe text at the bottom of the email"
	},
	"post-office.playground.go-faster-techops-rollup-notifier.sample-hello-message.no-translate": {
		"defaultMessage": "Hello, *This is notification test from post office*",
		"description": "hello message of the slack"
	},
	"post-office.playground.test-playground-message.sample-mobile-notification-message.no-translate": {
		"defaultMessage": "Hello, this is a mobile push notification test from post office.",
		"description": "hello message of the mobile notification"
	}
}